export type EnvironmentVariableType = {
  redirectURI: string;
  authRedirect: string;
  assetManagementBaseURL: string;
  clientId: string;
  deviceApiV2BaseUrl: string;
  userPreferencesV2BaseUrl: string;
  entitlementsV1BaseUrl: string;
  entitlementRoleManagementV1BaseUrl: string;
  transactionsV1BaseUrl: string;
  devicesV1BaseUrl: string;
  parsedMessageV1BaseUrl: string;
  commandsV1BaseUrl: string;
  carrierManagementV1BaseUrl: string;
  rebootConfigV1BaseUrl: string;
  rebootConfigV2BaseUrl: string;
  shortCommandsV1BaseUrl: string;
  shortCommandsV2BaseUrl: string;
  shortMessageRequestConfigurationV1BaseUrl: string;
  fileTypeConfigV1BaseUrl: string;
  fileTypeConfigV2BaseUrl: string;
  configurationFilesV1BaseUrl: string;
  configurationFilesLibraryV1BaseUrl: string;
  pingCommandsV2BaseUrl: string;
  saberRekeyV1BaseUrl: string;
  transferOverrideConfigurationsV1BaseUrl: string;
  globalSearchV2BaseUrl: string;
  meterValueConfigurationV2BaseUrl: string;
  geoFenceConfigBaseUrl: string;
  assetsV2BaseUrl: string;
  assetDeviceConfigV2BaseUrl: string;
  lastMessageTransmission: string;
  storageV1BaseUrl: string;
  subscriptionConfig: string;
  subscriptionConfigV2BaseUrl: string;
  subscriptionCatalogV1BaseUrl: string;
  homingV2BaseUrl: string;
  legacyMMSGatewaySupportPortalLink: string;
  remoteFlashV1BaseUrl: string;
  flashLogsV1: string;
  deviceWakeUpsV2: string;
  preferredNetworkAndOTASPV1: string;
  disableFaultCode: string;
  wifiConfigurationsV1: string;
  restrictedAssetsV1: string;
  tokenURI: string;
  antiForgeryTtl: number;
  proofCodeTtl: number;
  leniency: number;
  campaignURL: string;
  UserAccessManagementV1BaseUrl: string;
  configCapability: string;
  locatorCommandURL: string;
  vimsSFTPUsers: string;
  vimsSFTPReportV1: string;
  deviceMigrationV1: string;
  modemFlashFirmwareURL: string;
  switchConfigurationsV1: string;
  configManangementV1BaseUrl: string;
  panelConfigurationV1BaseUrl: string;
};

export const processEnvironmentVariables = (REACT_APP_ENV: string): EnvironmentVariableType => {
  const userAccessManagementV1BaseUrl =
    REACT_APP_ENV === 'dev' ? 'https://api-qa.cat.com/catDigital/userOnboarding/v1' : '/catDigital/userOnboarding/v1';
  const entitlementRoleManagementV1BaseUrl =
    REACT_APP_ENV === 'dev' ? 'https://api-qa.cat.com/catDigital/entitlementRoleManagement/v1' : '/catDigital/entitlementRoleManagement/v1';
  const entitlementsV1BaseUrl =
    REACT_APP_ENV === 'dev' ? 'https://api-qa.cat.com/catDigital/entitlements/v1' : '/catDigital/entitlements/v1';  
  return {
    redirectURI: '/redirect',
    authRedirect: '/as/authorization.oauth2',
    assetManagementBaseURL: '/assetManagement',
    deviceApiV2BaseUrl: '/iotgateway/deviceRadios/v2',
    devicesV1BaseUrl: '/iotgateway/v1/devices',
    assetsV2BaseUrl: '/iotgateway/v2/assets',
    assetDeviceConfigV2BaseUrl: '/iotgateway/assetDeviceConfig/v2',
    userPreferencesV2BaseUrl: '/catDigital/userPreferences/v2',
    entitlementsV1BaseUrl,
    entitlementRoleManagementV1BaseUrl,
    transactionsV1BaseUrl: '/iotgateway/v1/transactions',
    globalSearchV2BaseUrl: '/catDigital/globalSearch/v2',
    parsedMessageV1BaseUrl: '/iotgateway/messageParser/v1',
    clientId: 'SupportUI_ac_pkce_client',
    commandsV1BaseUrl: '/iotgateway/v1/commands',
    transferOverrideConfigurationsV1BaseUrl: '/iotgateway/transferOverride/v1',
    carrierManagementV1BaseUrl: '/iotgateway/v1/carrierManagement',
    shortCommandsV1BaseUrl: '/iotgateway/shortCommands/v1',
    shortCommandsV2BaseUrl: '/iotgateway/shortCommands/v2',
    shortMessageRequestConfigurationV1BaseUrl: '/iotgateway/shortMessageRequest/v1',
    saberRekeyV1BaseUrl: '/iotgateway/saberRekey/v1',
    rebootConfigV1BaseUrl: '/iotgateway/v1/rebootConfig',
    rebootConfigV2BaseUrl: '/iotgateway/rebootCommands/v2',
    fileTypeConfigV1BaseUrl: '/iotgateway/fileTypeConfigurations/v1',
    fileTypeConfigV2BaseUrl: '/iotgateway/fileTypeConfigurations/v2',
    configurationFilesV1BaseUrl: '/iotgateway/configurationFiles/v1',
    pingCommandsV2BaseUrl: '/iotgateway/pingCommands/v2',
    lastMessageTransmission: '/iotgateway/lastMessageTransmission/v1',
    meterValueConfigurationV2BaseUrl: '/iotgateway/meterValueAdjustmentConfig/v2',
    geoFenceConfigBaseUrl: '/iotgateway/geoFence/v1',
    configurationFilesLibraryV1BaseUrl: '/iotgateway/configurationFilesLibrary/v1',
    storageV1BaseUrl: '/catDigital/storage/v1',
    subscriptionConfig: '/iotgateway/v1/subscriptionConfig',
    subscriptionConfigV2BaseUrl: '/iotgateway/subscriptionConfig/v2',
    subscriptionCatalogV1BaseUrl: '/iotgateway/subscriptions/v1',
    homingV2BaseUrl: '/iotgateway/homing/v2',
    legacyMMSGatewaySupportPortalLink: 'https://servicetool.telematics-managed.com',
    remoteFlashV1BaseUrl: '/iotgateway/remoteFlash/v1',
    flashLogsV1: '/iotgateway/flashLogs/v1',
    deviceWakeUpsV2: '/iotgateway/deviceWakeups/v2',
    preferredNetworkAndOTASPV1: '/iotgateway/preferredNetworkAndOtasp/v1',
    disableFaultCode: '/iotgateway/disableFaultCode/v1',
    wifiConfigurationsV1: '/iotgateway/wifiConfigurations/v1',
    restrictedAssetsV1: '/catDigital/restrictedAssets/v1',
    tokenURI: '/as/token.oauth2',
    antiForgeryTtl: 30,
    proofCodeTtl: 25,
    leniency: 2,
    campaignURL: '/iotgateway/campaign/v1',
    UserAccessManagementV1BaseUrl: userAccessManagementV1BaseUrl,
    configCapability: '/iotgateway/configCapability/v1',
    locatorCommandURL: '/iotgateway/locatorCommands/v1',
    vimsSFTPUsers: '/iotgateway/vimsSftpUsers/v1',
    vimsSFTPReportV1: '/catDigital/vims/metadata/v1',
    deviceMigrationV1: '/iotgateway/deviceMigration/v1',
    modemFlashFirmwareURL: '/iotgateway/modemFlashFirmware/v1',
    switchConfigurationsV1: 'iotgateway/switchConfigurations/v1',
    configManangementV1BaseUrl: 'iotgateway/configManagement/v1',
    panelConfigurationV1BaseUrl: 'iotgateway/panelConfiguration/v1'
  };
};
